/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment } from 'react'
import { Table, Divider } from 'antd'
import styles from './index.less'
import moment from 'moment'


const FollowList = ({ data, onEdit }) => {
  const columns = [
    {
      dataIndex: 'typeName',
      title: '工作类别',
      width: 100,
    },
    {
      dataIndex: 'content',
      title: '随访情况',
      ellipsis:true
    },
    {
      dataIndex: 'comment',
      title: '备注',
      width: 140,
    },
    {
      dataIndex: 'createdAt',
      title: '创建时间',
      width: 140,
      align: 'center',
      render(text) {
        return text ? moment(text).format('YYYY-MM-DD HH:mm') : ''
      }
    },
    {
      dataIndex: 'operation',
      title: '操作',
      width: 100,
      align: 'center',
      render(text, record) {
        return <Fragment>
          <a href="javascript:void(0)" onClick={() => onEdit(record)}>编辑</a>
          {/* <Divider type="vertical" />
          <a href="javascript:void(0)" >查看</a> */}
        </Fragment>
      }
    }
  ]

  return (
    <div className={styles.follow}>
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        size="small"
        rowKey="id"
      />
    </div>
  )
}

export default FollowList